module.exports = __webpack_public_path__ + "static/media/19a-02_ST-2019-165x133cm-oleo-sobre-tela.e876fd73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-02_ST-2019-165x133cm-oleo-sobre-tela.jpg
// module id = 237
// module chunks = 0